<template>
  <div class="c-email-capture l-flex l-flex--column">
    <h3
      v-if="formTitle"
      class="c-email-capture__title t-heading-3 u-margin-bottom-small"
    >
      {{ formTitle }}
    </h3>
    <img
      v-else
      class="c-email-capture__img u-margin-bottom-medium"
      src="@/assets/emailCapture/First_to_Know.png"
      alt="Be the first to know by signing up for our newsletter"
    >
    <p
      v-if="formSubtitle"
      class="c-email-capture__description t-heading-6 u-margin-bottom-large"
    >
      {{ formSubtitle }}
    </p>
    <p
      v-else
      class="c-email-capture__description u-margin-bottom-large u-text-align-center"
    >
      Discover new silicone rings, colors, and promotions right when they come
      out.
    </p>
    <form
      v-if="submitStatus != 'PENDING' && submitStatus != 'OK'"
      class="c-email-form l-flex"
      novalidate
      @submit.prevent="submit"
    >
      <label
        class="c-email-form__label"
        for="email"
      />
      <div class="c-email-form__input-container">
        <tooltip
          :is-visible="submitStatus == 'EMPTY' || submitStatus == 'INVALID'"
          :message="submitStatus == 'EMPTY' ? statusEmpty : submitStatus ==
            'INVALID' ? statusInvalid : ''"
          :error="true"
          :hover="false"
        >
          <div
            class="c-email-form__input"
            :class="{ 'c-email-form__input--invalid': submitStatus == 'EMPTY' || submitStatus == 'INVALID' }"
          >
            <text-input
              id="email"
              v-model="email"
              placeholder="enter your email address"
              icon="envelope"
            />
          </div>
        </tooltip>
      </div>
      <btn
        class="c-email-form__submit"
        :button-size="buttonSize"
      >
        SUBMIT
      </btn>
    </form>
    <div v-if="submitStatus == 'PENDING'">
      <loader />
    </div>
    <div
      v-if="submitStatus == 'OK'"
      class="c-email-capture__message--container u-center-text"
    >
      <p class="t-heading-5">
        Thanks for subscribing!
      </p>
      <p class="t-paragraph-large">
        Check your email for a confirmation message.
      </p>
    </div>
  </div>
</template>

<script>
import Loader from '../loader/Loader'
import Btn from '../button/Btn'
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import Tooltip from '../tooltip/Tooltip'
import TextInput from '../inputs/TextInput'

export default {
  components: {
    TextInput,
    Btn,
    Loader,
    Tooltip
  },
  mixins: [validationMixin],
  props: {
    listId: {
      type: String,
      default: ''
    },
    formTitle: {
      type: String,
      default: null,
    },
    formSubtitle: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      email: '',
      submitStatus: null,
      disable: null,
      buttonSize: 'small',
      statusEmpty: 'This field is required',
      statusInvalid: 'Please enter a valid email address'
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  mounted() {
    let height = document.getElementsByClassName("c-email-form__input")[0].offsetHeight
    document.getElementsByClassName("c-email-form__submit")[0].setAttribute("style", `height: ${height}px`)
  },
  methods: {
    submit() {
      if (this.$v.email.$model === '') {
        this.submitStatus = 'EMPTY'
      } else if (this.$v.$invalid) {
        this.submitStatus = 'INVALID'
      } else {
        this.submitStatus = 'PENDING'
        this.subscribeCustomer(this.$v.email.$model)
        setTimeout(() => {
          this.submitStatus = 'OK'
        }, 500)
      }
    },
    async subscribeCustomer(email) {
      const listId = process.env.KLAVIYO_LIST_ID || this.listId

      return this.$axios({
        method: 'POST',
        baseURL: '/api',
        url: '/signup',
        data: {
          email,
          listId
        }
      }).catch(err => {
        throw new Error(err)
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.c-email-capture {
  padding: rem(50px) rem(30px);
  @include themify($themes) {
    background: themed('background', 'xx-light');
  }
  &__title {
    text-transform: uppercase;
  }
  &__img {
    width: 100%;
    max-width: rem(350px);
  }
}
.c-email-form {
  @include respond(phone) {
    flex-direction: column;
  }
  width: 100%;
  max-width: rem(640px);
  position: relative;
  &__submit {
    padding: 0px;
  }
  &__label {
    width: rem(0px);
    height: rem(0px);
    visibility: hidden;
  }
  &__input-container {
    flex-grow: 1;
    @include respond(phone) {
      width: 100%;
      margin-bottom: rem(15px);
    }
  }
  &__input {
    position: relative;
    input {
      @include respond(phone) {
        text-align: center;
        padding: 0;
      }
      width: 100%;
      height: rem(54px);
      padding: rem(10px) 0 rem(10px) rem(35px);
      border: $input-border;
      border-color: $input-border-color;
      &:focus {
        outline: none;
      }
      &:hover {
        @include themify($themes) {
          border-color: themed('foreground');
        }
      }
    }
    &--invalid {
      input {
        @include themify($themes) {
          border-color: themed('foreground', 'error');
        }
      }
    }
    &:before {
      content: url('~@/assets/icons/envelope.svg');
      width: rem(19px);
      position: absolute;
      left: rem(9px);
      top: 50%;
      transform: translateY(-50%)
    }
  }
  &__error {
    @include respond(phone) {
      width: 100%;
    }
    position: absolute;
    z-index: 1;
    top: rem(62px);
    left: 0;
    &--container {
      width: 100%;
      padding: rem(8px);
      border: $input-border;
      @include themify($themes) {
        border-color: themed('foreground', 'error');
      }
      border-radius: 4px;
      font-size: rem(18px);
      position: relative;
      @include themify($themes) {
        background-image: themed('background', 'x-light');
        color: themed('foreground', 'error');
      }

      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 0px;
        height: 0px;
        border-style: solid;
        border-width: 9px;
        left: 7px;
        top: -18px;
        @include themify($themes) {
          border-color: transparent transparent themed('foreground', 'error');
        }
      }
      &:after {
        content: '';
        display: block;
        position: absolute;
        width: 0px;
        height: 0px;
        border-style: solid;
        top: -16px;
        @include themify($themes) {
          border-color: transparent transparent themed('background', 'x-light');
        }
        left: 8px;
        border-width: 8px;
      }
    }
  }
  &__submit-button {
    @include respond(phone) {
      width: 100%;
      max-width: rem(400px);
    }
    border: none;
    height: rem(46px);
    width: rem(215px);
    cursor: pointer;
    @include themify($themes) {
      background: themed('foreground');
      border-color: themed('foreground');
      color: themed('foreground', 'white-text');
    }
  }
}
</style>
